import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { GridState } from '@shared';
import { Category } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private apiUrl: string = environment.apiUrl + '/categories';
  constructor(private httpClient: HttpClient) {}

  getAllCategories(state: GridState): Observable<GridDataResult> {
    return this.httpClient.get<GridDataResult>(
      `${this.apiUrl}?${toDataSourceRequestString(state)}`,
    );
  }

  updateCategory(category: Category): Observable<void> {
    const url = `${this.apiUrl}/${category.id}`;
    return this.httpClient.put<void>(url, category);
  }

  createCategory(category: Category): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}`, category, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  deleteCategory(id: number): Observable<any> {
    return this.httpClient.delete(`${this.apiUrl}/${id}`);
  }

  batchUpdateCategories(categories: any): Observable<any> {
    const url = `${this.apiUrl}/bulk-update`;
    return this.httpClient.put(url, categories);
  }
}
